import React from 'react';
import Typography from '@material-ui/core/Typography';
import { Theme, styled } from '@material-ui/core';
import { SpriteIcon } from 'src/config/api/models/FontAwesome';
import { FontAwesomeSpriteIcon } from '../FontAwesomeLocal';
import { useTheme } from '@material-ui/core';

const Title = styled(Typography)<Theme>(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(1, 3),
  margin: theme.spacing(0, -3),
  gap: theme.spacing(2),
  background: 'inherit',
}));

type Props = {
  title: string;
  icon: SpriteIcon;
};

export const SidebarTitle = ({ title, icon }: Props) => {
  const theme = useTheme();
  return (
    <Title variant="h2">
      <FontAwesomeSpriteIcon color={theme.palette.secondary.main} iconSize="md" icon={icon} />
      {title}
    </Title>
  );
};
